import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import React from 'react';
import type {FeedbackButtonProps} from './feedback-button.types';
import {Button, Size, Type} from '@Components/button';
import styles from './feedback-button.module.scss';
import {isSuperUser} from '@Libraries/user.library';

export function FeedbackButton({id, floatingFeedbackButtonProps = undefined, onClick = undefined}: FeedbackButtonProps): ReactElement<any>|undefined {
  const [isUserSuper, setIsUserSuper] = useState<boolean>(false);
  const [isHotjarFormVisible, setIsHotjarFormVisible] = useState<boolean>(false);

  useEffect(() => {
    void isSuperUser().then((isSuper) => {
      setIsUserSuper(isSuper);
    });
  }, []);

  const onClickBtn = (): void => {
    setIsHotjarFormVisible(!isHotjarFormVisible);

    if (onClick) {
      onClick();
    }
  }

  const getButton = (): ReactElement<any> => {
    return (
      <>
        <Button
          textClasses={styles.text}
          customClasses={styles.buttonContainer}
          type={Type.PRIMARY_DARK}
          size={Size.SMALL}
          icon="icon-chat"
          text={window.i18next.t('pmwjs_tell_us_about_your_experience')}
          onClick={onClickBtn}
        />
        {id ? getHotjarContent() : undefined}
      </>
    );
  }

  const getHotjarContent = (): ReactElement<any> => {
    return (
      <div className={`${styles.hotjarContainer} ${isHotjarFormVisible ? styles.hotjarVisible : ''}`}>
        <div id={id}>
        </div>
      </div>
    );
  }

  const getFloatingButton = (): ReactElement<any> => {
    const style: React.CSSProperties = {
      ...(floatingFeedbackButtonProps?.top !== undefined ? { top: floatingFeedbackButtonProps.top } : {}),
      ...(floatingFeedbackButtonProps?.bottom !== undefined ? { bottom: floatingFeedbackButtonProps.bottom } : {}),
      ...(floatingFeedbackButtonProps?.right !== undefined ? { right: floatingFeedbackButtonProps.right } : {}),
      ...(floatingFeedbackButtonProps?.left !== undefined ? { left: floatingFeedbackButtonProps.left } : {}),
    };

    return (
      <div className={styles.floatingContainer} style={style}>
        {getButton()}
      </div>
    );
  }

  if (!isUserSuper) {
    return undefined;
  }

  if (floatingFeedbackButtonProps) {
    return getFloatingButton();
  }
  return getButton();
}